import React from "react";
import { Sparkles, ShieldCheck, Award, Globe2, ArrowRight, Building2, Phone, MessageCircle } from "lucide-react";

const WelcomePoster = () => (
  <div className="md:col-span-7 relative">
    <div className="relative rounded-3xl overflow-hidden border border-[#E6EAF0] shadow-[0_24px_60px_rgba(0,43,127,0.10)]">
      <img
        src="/brand/welcome-banner.png?v=2"
        alt="Welcome to Marioway Benefits Consultancy LTD"
        className="w-full h-auto block"
        loading="eager"
        data-testid="welcome-poster"
      />
      <div className="absolute top-4 left-4">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#002B7F] text-white text-[11px] font-bold tracking-[0.16em]">
          <Sparkles size={12} className="text-[#FCD116]" /> WELCOME
        </span>
      </div>
    </div>
  </div>
);

const CompanyPresentation = () => (
  <div className="md:col-span-5">
    <span className="eyebrow"><Building2 size={12} /> About Marioway</span>
    <h2 className="font-display text-3xl sm:text-4xl mt-4 text-[#002B7F] leading-[1.05]" data-testid="welcome-headline">
      A trusted UK consultancy <span className="text-[#F37021]">built for real people.</span>
    </h2>

    <div className="mt-5 space-y-4 text-[15px] text-[#4A4A4A] leading-relaxed">
      <p>
        <span className="font-bold text-[#002B7F]">Marioway Benefits Consultancy LTD</span> is an independent UK consultancy registered in England and Wales (Company Number <span className="font-mono text-[#002B7F]">12784422</span>) and based in <span className="font-semibold">Leeds</span>. We provide independent administrative, welfare support, accounting administration, education support and business support services to individuals, families and small businesses across the UK.
      </p>
      <p>
        From <span className="font-semibold">Universal Credit</span> and <span className="font-semibold">EU Settlement documentation</span> to <span className="font-semibold">Self Assessment administration</span>, <span className="font-semibold">Student Finance</span> and <span className="font-semibold">Council Tax Support</span> — we support you with documentation and applications at every step.
      </p>
      <p>
        Our team speaks <span className="font-bold text-[#CE1126]">English</span>, <span className="font-bold text-[#FCD116]" style={{ WebkitTextStroke: "0.6px #C9A100" }}>Romanian</span> and <span className="font-bold text-[#1F5D2D]">Spanish</span> — making sure no one is left behind because of language. Clear, professional support. Long-term assistance.
      </p>
    </div>

    <div className="mt-7 grid grid-cols-3 gap-3">
      {[
        { icon: ShieldCheck, k: "Independent", v: "Administrative Support" },
        { icon: Award, k: "Trusted", v: "Companies House Registered" },
        { icon: Globe2, k: "EN · RO · ES", v: "Multilingual Service" },
      ].map(({ icon: I, k, v }) => (
        <div key={k} className="rounded-xl border border-[#E6EAF0] bg-[#F5F7FA] p-3">
          <I size={18} className="text-[#F37021]" />
          <div className="mt-2 font-bold text-[13px] text-[#002B7F]">{k}</div>
          <div className="text-[11px] text-[#4A4A4A] leading-tight mt-0.5">{v}</div>
        </div>
      ))}
    </div>

    <div className="mt-7 flex flex-wrap gap-3">
      <a href="tel:07383513170" className="btn-orange" data-testid="welcome-cta-call">
        <Phone size={16} /> Call 07383513170
      </a>
      <a
        href="https://wa.me/447383513170"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-ghost"
        data-testid="welcome-cta-whatsapp"
      >
        <MessageCircle size={16} /> WhatsApp
      </a>
      <a href="/#services" className="inline-flex items-center gap-1.5 px-4 py-3 text-[#002B7F] font-bold hover:text-[#F37021] transition-colors" data-testid="welcome-cta-services">
        See 10 core services <ArrowRight size={16} />
      </a>
    </div>
  </div>
);

const Pillars = () => (
<div className="mt-14 grid sm:grid-cols-3 gap-5">
  {[
    {
      t: "CONSULTANCY",
      d: "Clear, professional guidance based on your circumstances.",
      color: "#002B7F",
    },
    {
      t: "ADMINISTRATIVE SUPPORT",
      d: "Practical solutions for your everyday needs.",
      color: "#F37021",
    },
    {
      t: "SOLUTIONS FOR YOU",
      d: "Helping you understand the process and complete your documentation.",
      color: "#CE1126",
    },
  ].map((p, i) => (
    <div key={p.t} className="rounded-2xl border border-[#E6EAF0] bg-white p-6 hover:shadow-[0_18px_40px_rgba(0,43,127,0.08)] transition-shadow" data-testid={`pillar-${i}`}>
      <div className="text-[12px] font-bold tracking-[0.18em]" style={{ color: p.color }}>
        {p.t}
      </div>
      <div className="mt-3 h-[3px] w-10 rounded-full" style={{ background: p.color }} />
      <p className="mt-4 text-[#1A1A1A] text-[15px] leading-relaxed">{p.d}</p>
    </div>
  ))}
</div>
);

export const WelcomeBanner = () => (
  <section id="welcome" className="bg-white">
    <div className="container-x py-12 md:py-20">
      <div className="grid md:grid-cols-12 gap-10 items-center">
        <WelcomePoster />
        <CompanyPresentation />
      </div>
      <Pillars />
    </div>
  </section>
);
